import * as React from 'react';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { SCREEN_TABLET } from '../../config/constants';
const InfoListItem = props => {
  const {
    title,
    body,
    icon
  } = props;
  const {
    width
  } = useWindowDimensions();
  return /*#__PURE__*/React.createElement("div", {
    className: "InfoListItem"
  }, /*#__PURE__*/React.createElement("div", {
    className: "InfoListItem__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "InfoListItem__icon"
  }, icon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "InfoListItem__title"
  }, title), width >= SCREEN_TABLET && /*#__PURE__*/React.createElement("p", {
    className: "InfoListItem__body"
  }, body))), width < SCREEN_TABLET && /*#__PURE__*/React.createElement("p", {
    className: "InfoListItem__body"
  }, body));
};
export default InfoListItem;